export const ironData = [
  {
    id: "GT-DIA_CB",
    img: "images/fitting/GT-DIA_CB.Webp",
    title: "GT - DIA CB",
    link: "GT-DIA_CB",
    price: "3,150,000",
    src: "images/gtdProduct/GT-DIA_CB",
  },
  {
    id: "GT-MB",
    img: "images/fitting/GT-MB.Webp",
    title: "GT - MB",
    link: "GT-MB",
    price: "3,080,000",
    src: "images/gtdProduct/GT-MB",
  },
  {
    id: "GT01",
    img: "images/fitting/GT-01.Webp",
    title: "GT - 01",
    link: "GT01",
    price: "2,400,000",
    src: "images/gtdProduct/GT01",
  },
];
